<template>
  <div class="extra-style-page">
    <img src="../../assets/images/extra-style/extra-notice.jpg">
    <img src="../../assets/images/extra-style/title.jpg">
    <img class="ranking" src="../../assets/images/extra-style/ranking.png" @touchstart="hanldeViewRanking">
    <!-- <img class="center" src="../../assets/images/extra-style/center.png" @click="hanldeViewPhoto"> -->
    <div class="container">
      <div class="activity-rule">
        <img src="../../assets/images/extra-style/rule.png">
        <img class="activity-rule-deco" src="../../assets/images/extra-style/deco-1.png">
      </div>
      <div class="activity-prize">
        <img src="../../assets/images/extra-style/prize.png">
        <img class="activity-prize-deco" src="../../assets/images/extra-style/deco-2.png">
      </div>
      <div class="activity-desc">
        <img src="../../assets/images/extra-style/desc.png">
        <img class="activity-desc-deco" src="../../assets/images/extra-style/deco-3.png">
      </div>
      <div class="activity-photo">
        <img src="../../assets/images/extra-style/my-photo.png" @touchstart="hanldeViewPhoto">
        <img src="../../assets/images/extra-style/upload-btn.png" @touchstart="hanldeUploadPhoto">
      </div>
    </div>
  </div>
</template>

<script>
import extraStyleApi from '@/api/extra-style'
export default {
  name: 'ExtraStyle',
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    hanldeViewRanking () {
      console.log('to ranking')
      this.$router.push({ name: 'extra-style-ranking' })
    },
    hanldeViewPhoto () {
      console.log('to center')
      this.$router.push({ name: 'extra-style-center' })
    },
    hanldeUploadPhoto () {
      const acticityTime = this.checkedActivityTime()
      console.log('acticityTime', acticityTime)
      if (!acticityTime) return
      extraStyleApi.queryExtraStyleAuthorize().then((response) => {
        if (response.data.resultCode === '0') {
          const count = response.data.resultData.count
          if (count > 0) {
            this.$router.push({ name: 'extra-style-template' })
          } else {
            console.log('to center')
            this.$dialog.confirm({
              title: '授权提示',
              message: '本人自愿将肖像权许可易加网在活动期间做符合法律规定的用途，并在特定范围内传播。'
            }).then(() => {
              // on confirm
              extraStyleApi.saveExtraStyleAuthorize().then((response) => {
                if (response.data.resultCode === '0') {
                  this.$dialog.alert({ message: '授权成功' }).then(() => {
                    this.$router.push({ name: 'extra-style-template' })
                  })
                }
              })
            }).catch(() => {
              // on cancel
              this.$dialog.alert({ message: '授权失败' })
            })
          }
        }
      })
    },
    checkedActivityTime () {
      const currentTime = new Date().getTime()
      const startTime = new Date('2020/02/25 00:00:00').getTime()
      const endTime = new Date('2020/12/14 00:00:00').getTime()
      if (currentTime < startTime) {
        this.$toast({ message: '活动尚未开始' })
        return false
      }
      if (currentTime > endTime) {
        this.$toast({ message: '活动已结束' })
        return false
      }
      if (currentTime < endTime && currentTime > startTime) {
        return true
      }
    }
  }
}
</script>

<style lang="less" scoped>
.extra-style-page {
  position: relative;
  width: 100%;
  font-size: 0;
  img {
    width: 100%;
  }
  .ranking {
    position: absolute;
    top: 70px;
    right: 0;
    width: 80px;
  }
  .container {
    background: url('../../assets/images/extra-style/bg.jpg') no-repeat;
    background-size: 100% 100%;
    .activity-rule, .activity-prize, .activity-desc {
      position: relative;
    }
    .activity-rule-deco {
      position: absolute;
      bottom: -10px;
      right: 0;
      width: 100%;
      z-index: 2;
    }
    .activity-prize-deco {
      position: absolute;
      top: 140px;
      right: 0;
      width: 105%;
      height: 100%;
      z-index: 2;
    }
    .activity-desc-deco {
      position: absolute;
      bottom: -20px;
      right: 0;
      width: 100%;
      z-index: 0;
    }
    .activity-photo {
      line-height: 80px;
      text-align: center;
      img {
        width: 120px;
        vertical-align: middle;
      }
      img:nth-child(1) {
        width: 125px;
        padding-right: 10px;
      }
    }
  }
}
</style>
